import "./Filter.scss";
import { isSignedIn } from '../../utils/util';
import { useTranslation } from "react-i18next";
import Panel from '@clayui/panel';
import React, { useEffect,useState } from 'react';

const Filter = ({
  completedCoursesLabel,
  hideCompletedCourses,
  isCompletedCourses,
  items,
  onChange,
  setHideCompletedCourses,
  selectedItems,
  title
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [showAllCheckboxes, setShowAllCheckboxes] = useState(false);

  const { t } = useTranslation();

  const clearCheckboxes = () => {
    onChange([]);
  };

  const handleCheckboxChange = (itemName) => {
    const newSelectedItems = selectedItems.includes(itemName)
      ? selectedItems.filter((name) => name !== itemName)
      : [...selectedItems, itemName];

    onChange(newSelectedItems);
  };  

  const selectAllItems = () => {
    const allItemNames = (items || []).map(item => item.name);

    onChange(allItemNames);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsExpanded(true);
      if (window.innerWidth <= 990) {
        setIsExpanded(false);
      }
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {(!isCompletedCourses || isSignedIn()) && (
        <div className="search-facet">
          <div>
            <Panel
              className="facet-panel"
              collapsable
              displayTitle={title}
              displayType="primary"
              expanded={isExpanded}
              onExpandedChange={setIsExpanded}
              showCollapseIcon={true}
            />

            {!isCompletedCourses && (
              <div className="facet-actions actionBtns">
                <button
                  className="btn btn-unstyled c-mb-3 facet-clear-btn action-buttons"
                  onClick={selectAllItems}
                  type="button"
                >
                  <span>{t("select-all")}</span>
                </button>
                <button
                  className="action-buttons btn btn-unstyled c-mb-3 facet-clear-btn"
                  onClick={clearCheckboxes}
                  type="button"
                >
                  <span>{t("clear")}</span>
                </button>
              </div>
            )}
            {isExpanded && (
              <Panel.Body>
                {isCompletedCourses && completedCoursesLabel && (
                  <ul className="checkbox-filters-container">
                    <li>
                      <label className="form-check">
                        <div className='checkbox-filters'>
                          <input
                            checked={hideCompletedCourses}
                            className="form-check-input"
                            onChange={(e) => setHideCompletedCourses(e.target.checked)}
                            type="checkbox"
                          />
                        </div>
                        <span className="custom-control-label-text text-facets">
                          {completedCoursesLabel}
                        </span>
                      </label>
                    </li>
                  </ul>
                )}
                {items && items.length > 0 && (
                  <ul className="checkbox-filters-container">
                    {items
                      .filter((item) => isSignedIn() || item.name !== "Sales")
                      .slice(0, showAllCheckboxes ? items.length : 8)
                      .map((item) => (
                        <li key={item.name}>
                          <label className="form-check">
                            <input
                              checked={selectedItems.includes(item.name)}
                              className="form-check-input"
                              onChange={() => handleCheckboxChange(item.name)}
                              type="checkbox"
                              value={item.name}
                            />
                            <span className="custom-control-label-text text-facets">
                              {item.name}
                            </span>
                          </label>
                        </li>
                      ))
                    }
                    {items.length > 8 && (
                      <li className="see-all-button">
                        <button
                          className="see-all-checkboxs"
                          onClick={() => setShowAllCheckboxes(!showAllCheckboxes)}
                          type="button"
                        >
                          {showAllCheckboxes ? '' : t("view-all")}
                        </button>
                      </li>
                    )}
                  </ul>
                )}
              </Panel.Body>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Filter;
